import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "AccountProfileEdit" })
export default class AccountProfileEdit extends Vue {
    public localizer: any = Localizer;
    public formHelper: any = FormHelper;
    public isLoading: boolean = true;
    public isLoadingForm: boolean = false;
    public isSuccess: boolean = false;
    public provinces: any[] = [];
    public profileTaxTypes: any[] = [];
    public countries: any[] = [];
    public activityTypes: any[] = [];
    public editData: any = null;
    public formData: any = { province: null, profileTaxType: null, country: null, activityType: null, profileSegment: null, shippingMode: null };
    public validationErrors: any[] = [];
    public isCompany: boolean = false;
    public isItalyCountry: boolean = false;
    public profileSegments: any[] = [];
    public isEditAddress: boolean = false;
    public shippingModes: any[] = [];
    public shippingAddressCount: number = 0;
    public shippingAddress: any = {};

    @Prop() readonly returnUrl: string;

    get routes() {
        return (<any>window).App.routes;
    }

    public async created() {
        this.isLoading = true;
        await this.getData();
        this.isLoading = false;
    }

    public async getData() {
        this.editData = (await Axios.post(this.routes.MyBeghelliProfile_GetProfileEditData, null)).data;

        this.formData.name = this.editData.name;
        this.formData.surname = this.editData.surname;
        this.formData.address = this.editData.address;
        this.formData.city = this.editData.city;
        this.formData.postCode = this.editData.postCode;
        this.formData.province = this.editData.province == "" ? null : this.editData.province;
        this.formData.country = this.editData.country == "" ? null : this.editData.country;
        this.formData.profileTaxType = this.editData.profileTaxType == "" ? "Persona fisica" : this.editData.profileTaxType;
        this.formData.taxCode = this.editData.taxCode;
        this.formData.ivaCode = this.editData.ivaCode;
        this.formData.sdiCode = this.editData.sdiCode;
        this.formData.certifiedEmail = this.editData.certifiedEmail;
        this.formData.activityType = this.editData.activityType == "" ? null : this.editData.activityType;
        this.formData.phoneNumber = this.editData.phoneNumber;
        this.formData.profileSegment = this.editData.profileSegment == "" ? null : this.editData.profileSegment;
        this.shippingModes = this.editData.shippingModes;
        this.shippingAddressCount = this.editData.shippingAddressCount;

        this.formData.shippingMode = this.shippingAddressCount == 0 ? "ProfileAddress" : null;

        this.provinces = this.editData.provinces;
        this.profileTaxTypes = this.editData.profileTaxTypes;
        this.countries = this.editData.countries;
        this.activityTypes = this.editData.activityTypes;
        this.profileSegments = this.editData.profileSegments;

        this.onProfileTaxTypeChanged();
        this.onCountryChanged();
    }

    public onProfileTaxTypeChanged() {
        this.formData.profileTaxType === "Persona giuridica" ? this.isCompany = true : this.isCompany = false;
        if (this.isCompany) {
            this.formData.surname = null;
        } else {
            this.formData.ivaCode = null;
            this.formData.activityType = null;
            this.formData.sdiCode = null;
            this.formData.certifiedEmail = null;
        }
    }

    public onCountryChanged() {
        this.formData.country === "IT" ? this.isItalyCountry = true : this.isItalyCountry = false;
    }

    public async submitForm() {
        FormHelper.removeFocus();
        this.validationErrors = [];
        this.isLoadingForm = true;

        this.formData.shippingMode !== "ProfileAddress" ? this.shippingAddress = {} : null;

        try {
            if (this.formData.shippingMode === "ProfileAddress" && this.shippingAddressCount === 0) {
                this.shippingAddress.name = this.formData.name;
                this.shippingAddress.surname = this.formData.surname;
                this.shippingAddress.address = this.formData.address;
                this.shippingAddress.postCode = this.formData.postCode;
                this.shippingAddress.location = this.formData.city;
                this.shippingAddress.zone = this.formData.province;
                this.shippingAddress.country = this.formData.country;
                this.shippingAddress.phone = this.formData.phoneNumber;
                this.shippingAddress.isDefault = true;

                await Axios.post(this.routes.MyBeghelliShippingAddress_SaveShippingAddress, this.shippingAddress);
                this.formData.shippingMode = null;

                this.shippingAddressCount++;
                (<any>this.$refs.childComponentRef).getData();
            }
            const result = (await Axios.post(this.routes.MyBeghelliProfile_ProfileEdit, this.formData)).data;

            if (result.redirectUrl || this.returnUrl) {
                window.location.href = result.redirectUrl ? result.redirectUrl : (this.returnUrl ? this.returnUrl : "/");
            }

            this.$store.dispatch("appToastStore/onAddToast", { message: this.localizer.get("App.Common.SuccessfullyUpdatedData"), type: "Success" });

            this.isSuccess = true;
            setTimeout(x => { this.isSuccess = false }, 2500);
        } catch (error) {
            if (error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }

        this.isLoadingForm = false;
    }

    public async controlEdit(value: any) {
        this.shippingAddressCount = (await Axios.post(this.routes.MyBeghelliShippingAddress_GetShippingAddresses)).data.addresses.length;
        this.isEditAddress = value;
        this.formData.shippingMode = "ProfileAddress";
    }

    public setShippingMode() {
        if (this.formData.shippingMode === "ProfileAddress") {
            this.isEditAddress = false;
        } else {
            this.isEditAddress = true;
        }
    }

    public goBack() {
        this.returnUrl ? window.location.href = this.returnUrl : history.back();
    }
};